import { useAuthStore } from "~/store/auth";

// noinspection JSUnusedGlobalSymbols
export default defineNuxtRouteMiddleware(async () => {
	const authStore = useAuthStore();
	const user = authStore.user;
	if (!user) return navigateTo("/login"); // redirect to login otherwise
	const userAccount = authStore.userAccount;
	if (!userAccount) return navigateTo("/login"); // redirect to user account select page
});
